var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoV1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title11"
  }, "What's The Word Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title11"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#a6a6d7",
      strokeWidth: 45.3153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 53.02756,147.65103 C 207.51166,134.96944 861.39362,367.09808 972.7711,376.09396 875.48999,389.11732 192.12267,219.51313 41.169193,219.51313 162.72215,262.37488 857.30023,420.85031 956.07794,456.39322 868.8604,466.16074 126.25013,317.84847 25.614487,317.84847 106.68093,365.24808 858.49929,487.5805 975.96423,528.96637 851.84695,545.24558 29.56693,429.39174 29.56693,429.39174 144.03261,474.67001 821.11662,583.26593 942.178,626.40865 833.85662,630.09347 159.42256,529.85404 43.616488,523.24938 290.78769,585.17515 620.64173,638.46632 896.73622,714.12998 735.55327,711.75891 49.468853,593.71726 49.468853,593.71726 120.75043,635.17226 833.39594,784.96757 833.39594,784.96757 712.25187,807.72591 77.049118,691.74599 77.049118,691.74599 123.12685,721.56092 764.59032,866.33288 764.59032,866.33288 583.5817,839.00955 92.195159,765.93593 57.677583,791.19898",
    id: "path7033"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2e335e",
      strokeWidth: 57.4661,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 91.008047,297.08345 c 0.112572,-68.70506 -1.180271,-167.07856 99.667743,-188.2412 117.46664,-24.377605 157.2753,245.28449 161.24419,321.44505 32.75069,-74.26812 139.95945,-107.36028 189.8254,-94.61719 55.52015,14.188 109.31227,75.85291 96.3072,164.68985 C 705.57623,382.82471 881.78706,293.51453 945.93771,402.2558 999.18894,504.9775 739.2745,871.4878 610.58327,885.33901 483.06461,891.57068 437.58714,816.83232 422.80802,726.24651 376.96863,789.03734 219.51402,812.29793 146.27976,753.93675 67.170239,690.89347 104.01546,405.48127 47.150803,342.62152",
    id: "path2732"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV1);
export default __webpack_public_path__ + "static/media/logo-v1.6f631c3123ceb5dd92e92fa5d4b366d3.svg";
export { ForwardRef as ReactComponent };